export default __webpack_public_path__ + "static/media/bookese-logo.c7660116.svg";